import styled from "styled-components/macro";

export const StyledPageWrapper = styled.div`
  justify-content: center;
  padding-top: 5vh;
  padding-bottom: 5vh;
  display: flex;
  font-family: poppins, sans-serif;
  max-width: 1200px;
  position: relative;
  overflow: visible;
  width: 80vw;
  margin: auto;

  @media screen and (max-width: 1000px) {
    width: 100%;
    margin: 0px;
    padding: 0px;
  }
`;

export const ContentWrapper = styled.div`
  width: 70%;
  margin-top: 0;
  padding: 70px 100px;
  text-align: left;
  border: 1px solid rgba(15, 23, 42, 0.08);
  border-radius: 32px;
  box-shadow: 0 24px 70px rgba(15, 23, 42, 0.08);
  backdrop-filter: blur(16px);

  @media screen and (max-width: 1000px) {
    width: 100%;
    margin: 0;
    padding: 24px 18px;
    border-radius: 24px;
    .MuiGrid-root,
    .MuiGrid-container {
      width: 100%;
      margin: 0;
    }
    img.background {
      display: none;
    }
    .MuiSvgIcon-root {
      display: none;
    }
  }
`;

export const Paragraph = styled.p`
  font-size: 18px;
  font-weight: 200;
  margin: 30px 0 20px 0;
  color: rgb(65, 65, 88);
  font-family: "Abcrepro Screen", sans-serif;
  line-height: 1.7;
`;

export const IntroText = styled.p`
  font-size: 24px;
  color: #6b8dcbff;
  font-weight: 400;
  margin: 30px 0 20px;
  line-height: 38px;
  font-family: "EB Garamond", serif;
`;

export const PageTitle = styled.div`
  font-family: "DM Serif Display", serif;
  font-size: 80px;
  font-weight: 100;
  color: #38384f;
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  @media screen and (max-width: 1000px) {
    font-size: 50px;
  }
`;

export const SectionTitleH2 = styled.h2`
  font-size: 28px;
  font-weight: 400;
  font-style: italic;
  color: #6b8dcbff;
  font-family: EB Garamond, serif;
  margin: 60px 0 10px 0;
`;

export const ItalicNote = styled.p<{ alignRight?: boolean }>`
  font-size: 16px;
  font-weight: 200;
  font-style: italic;
  font-family: "EB Garamond", serif;
  line-height: 1.7;
  color: #6e6d6dff;
  margin-top: 20px;
  ${({ alignRight }) => alignRight && `float: right;`}
`;

export const Divider = styled.div<{ width?: number }>`
  margin: 20px 0px 60px 0px;
  border: 0;
  height: 1px;
  background-image: linear-gradient(
    to right,
    #a7aaafff,
    rgba(103, 84, 130, 0.52),
    rgba(255, 255, 255, 0)
  );

  @media screen and (max-width: 1000px) {
    margin: 20px 0px 20px 0px;
  }
`;

export const ProjectContainer = styled.div`
  margin: 40px 0;
  position: relative;
`;

export const ProjectHeader = styled.div`
  margin-bottom: 20px;
`;

export const ProjectTitle = styled.h3`
  font-size: 24px;
  font-family: EB Garamond, serif;
  color: #38384f;
  margin: 0 0 8px 0;
  font-weight: 400;
`;

export const ProjectSubtitle = styled.h4`
  font-size: 20px;
  color: #6b8dcbff;
  font-family: "EB Garamond", serif;
  font-weight: 400;
  font-style: italic;
  margin: 0 0 20px 0;
`;

export const ProjectDescription = styled.p`
  font-size: 16px;
  line-height: 1.7;
  color: rgb(65, 65, 88);
  font-family: "Abcrepro Screen", sans-serif;
  margin: 0 0 25px 0;
  font-weight: 200;
`;
